import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
import { useEffect, useState } from 'react';
import { Spinner, Box } from '@chakra-ui/react';
function Giphy({ searchQuery, searched, onSelect,onLoad, ...props }) {
  const [fetched, setFetched] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
  const giphyFetch = new GiphyFetch('EZ2HTEFqs0ZAA6gCPEUHwmWG21LI7RXG');
  const width = 280;

  const fetchGif = () => {
      setIsLoading(true);
   
     const fetchPromise = searched ? searchGifs() : trendingGifs();
    
    fetchPromise
      .then((res) => {
        setFetched(true);
        setIsLoading(false);
        // Call onLoad callback if provided
        if (onLoad) {
          onLoad();
        }
      })
      .catch((error) => {
        console.error('Error fetching GIFs:', error);
        setIsLoading(false);
        // Still call onLoad even on error to hide external spinners
        if (onLoad) {
          onLoad();
        }
      });
  };

  function trendingGifs() {
    return giphyFetch.trending({ limit: 16 });
  }

  function searchGifs() {
    return giphyFetch.search(searchQuery, { limit: 16 });
  }

  useEffect(() => {
    setFetched(false);
    fetchGif();
  }, [searched, searchQuery]);

  return (
      <Box position="relative" minHeight="200px">
      {/* Loading overlay */}
      {isLoading && (
        <Box 
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          backgroundColor="rgba(255, 255, 255, 0.8)"
          zIndex="10"
        >
          <Spinner 
            size="lg" 
           
          />
         </Box>
      )}
    {fetched && (
      <Grid
        hideAttribution={true}
        noLink={true}
        noResultsMessage="No Data Found!"
        fetchGifs={searched ? searchGifs : trendingGifs}
        width={width}
        borderRadius={10}
        onGifClick={onSelect}
        columns={4}
        gutter={5}
        {...props}
      />
     )}
    </Box>
 
  );
}

export default Giphy;
